var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("va-card", { staticClass: "pa-6" }, [
        _c("h3", { staticClass: "text-center mb-6" }, [
          _vm._v(_vm._s(_vm.$t("roomWizard.insertCode")))
        ]),
        _c(
          "div",
          { staticClass: "d-flex justify-space-around my-8" },
          [
            _c("v-otp-input", {
              staticClass: "otp-input",
              attrs: { disabled: _vm.isLoading || _vm.loading },
              on: { input: _vm.onInput },
              model: {
                value: _vm.code,
                callback: function($$v) {
                  _vm.code = $$v
                },
                expression: "code"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "d-flex justify-space-between my-8" },
          [
            _c("v-spacer"),
            _c("va-button", {
              attrs: {
                disabled: _vm.code.length !== 6,
                loading: _vm.isLoading || _vm.loading,
                cta: _vm.$t("roomWizard.next")
              },
              on: { click: _vm.connectToRoom }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }